import lodash from 'lodash';

class Sorting {
    public makeOrderSymfony(sorting?: AnyObject): AnyObject {
        const order: AnyObject = {};
        lodash.forEach(sorting, (value: any, key: string) => {
            order[`order[${key}]`] = value;
        });

        return order;
    }
    public makeOrder(sorting?: AnyObject): string | null {
        if (!sorting) {
            return null;
        }

        let order: string | null = null;
        lodash.forEach(sorting, (value: any, key: string) => {
            if (order === null) {
                order = '';
            }

            order += `${value === 'asc' ? '+' : '-'}${key}`;
        });

        return order;
    }
}

const sortingService = new Sorting();

export default sortingService;
